import React from 'react';
import './App.css';
import HomePage from './Pages/HomePage/HomePage';

const App = () => {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
